<!-- @format -->

<!-- Image Badge -->
@if (cleanImageBadge()) {
	<div class="badge-container hmf-w-100 hmf-px-s">
		<hmf-badge
			class="badge-overlay"
			[badgeName]="cleanImageBadge()" />
	</div>
}

<div
	class="image-viewer-container"
	[ngClass]="{
		'out-of-stock-image-container':
			!alternativeInStockRecsEnabled() && shouldShowOutOfStockRecs() === true,
		'pl-image-container': shouldHaveBorder()
	}">
	<div
		class="image-container hmf-w-100 hmf-display-flex hmf-flex-column hmf-align-items-center hmf-position-relative">
		<!-- Hero image -->
		<!-- image unavailable -->
		@if (imageUnavailable) {
			<picture
				class="hmf-display-flex hmf-align-items-center hmf-justify-content-center image-unavailable">
				<source
					media="(min-width: 1200px)"
					type="image/webp"
					[srcset]="heroImage.poster + '?qlt=70&wid=640&fmt=webp&op_sharpen=1'" />
				<source
					media="(min-width: 1200px)"
					[srcset]="heroImage.poster + '?qlt=70&wid=640&fmt=pjpeg&op_sharpen=1'" />
				<source
					media="(min-width: 768px)"
					type="image/webp"
					[srcset]="heroImage.poster + '?qlt=70&wid=400&fmt=webp&op_sharpen=1'" />
				<source
					media="(min-width: 768px)"
					[srcset]="heroImage.poster + '?qlt=70&wid=400&fmt=pjpeg&op_sharpen=1'" />
				<source
					type="image/webp"
					[srcset]="heroImage.poster + '?qlt=70&wid=350&fmt=webp&op_sharpen=1'" />
				<img
					class="gallery-image"
					[ngSrc]="heroImage.poster + '?qlt=70&wid=350&fmt=pjpeg&op_sharpen=1'"
					[alt]="productName() + ' product'"
					itemprop="image"
					[attr.fetchpriority]="'high'"
					[width]="350"
					[height]="350" />
			</picture>
		} @else {
			<div
				class="image-viewer-hero-container"
				[class.out-of-stock-image-viewer-hero-container]="!alternativeInStockRecsEnabled() && shouldShowOutOfStockRecs() === true"
				[class.hmf-display-md-flex]="isHybridPLA()"
				>
				@if (isHybridPLA()) {
					<div class="nav-button nav-button--left hmf-display-none hmf-display-md-flex hmf-align-items-center hmf-flex-shrink-none">
						@if (altImageActiveIndex() > 0) {
							<button hmf-button variant="secondary" aria-label="Left" class="hmf-p-0" (click)="scrollCarousel(false)">
								<homefield-icon name="chevron-left" width="16" height="16"></homefield-icon>
							</button>
						}
					</div>
					<div class="nav-button nav-button--right hmf-display-none hmf-display-md-flex hmf-align-items-center hmf-flex-shrink-none">
						@if (altImageActiveIndex() < mediaSetItems.length - 3) {
							<button hmf-button variant="secondary" aria-label="Right" class="hmf-p-0" (click)="scrollCarousel(true)">
								<homefield-icon name="chevron-right" width="16" height="16"></homefield-icon>
							</button>
						}
					</div>
				}
				<!-- Placeholder while its loading items -->
				@if (mediaSetItems?.length === 0) {
					<div class="placeholder"></div>
				} @else if (mediaSetItems?.length > 1) {
					<div
						class="gallery hmf-mx-0 hmf-position-relative"
						(scroll)="handleGalleryScroll($event.target)">
						@for (
							mediaSetItem of mediaSetItems | slice: 1 : mediaSetItems.length;
							track $index
						) {
							<div class="image-viewer-swatch-col gallery-item"
								 [class.hmf-px-s]="!isHybridPLA()"
								 [class.hmf-py-xs]="!isHybridPLA()">
								<button
									type="button"
									[id]="'image-viewer-hero-wrapper-' + eCode()"
									class="image-viewer-hero-wrapper hmf-h-100 hmf-w-100 hmf-mx-auto hmf-px-0"
									[ngClass]="{ 'pl-border': chainIdentifierAbbr === 'pl' }"
									(click)="
										loadContent(
											mediaSetItem.index,
											'HeroImage',
											mediaSetItem.type
										)
									">
									<picture
										class="hmf-position-relative hmf-display-flex hmf-align-items-center hmf-justify-content-center">
										@if (mediaSetItem.type !== 'video') {
											<pdp-pinch-to-zoom
												[minScale]="1"
												[disablePan]="false"
												[limitZoom]="10"
												[limitPan]="false"
												#pinch>
												<!-- this div creates reference coordinates for the syndigo hotspots -->
												<div class="hmf-position-relative">
													@if (
														mediaSetItem?.templateSrc === defaultImage
													) {
														<img
															class="gallery-optimize-image"
															[src]="mediaSetItem?.templateSrc"
															[alt]="productName() + ' product'"
															itemprop="image"
															loading="lazy" />
													} @else {
														<shared-media-component-optimized-image
															class="gallery-optimize-image"
															[altText]="
																productName() + ' product image'
															"
															[isPriority]="
																setImageAsPriority($index)
															"
															[loadingStrategy]="
																setLoadingStrategy($index)
															"
															[imageLoaderConfig]="{
																src: mediaSetItem?.templateSrc,
																loaderParams: {
																	sizes: sizesAttribute(),
																	isUrlEmbeded: true,
																	fit: isHybridPLA() ? 'fit' : 'constrain',
																	squareAspectRatio: true
																}
															}"
															(handleError)="
																handleImageError($index + 1)
															">
														</shared-media-component-optimized-image>
													}
												</div>
											</pdp-pinch-to-zoom>
										} @else {
											<shared-media-component-optimized-image
												class="hmf-px-m"
												[altText]="productName() + ' product'"
												[imageLoaderConfig]="{
													src: mediaSetItem?.templateSrc,
													loaderParams: {
														sizes: sizesAttribute(),
														isUrlEmbeded: true
													}
												}">
											</shared-media-component-optimized-image>
											<homefield-icon
												width="35px"
												height="35px"
												name="{{
													chainIdentifierAbbr === 'pl'
														? 'pl-media-play'
														: 'media-play'
												}}"
												class="video-cover"
												fill="var(--hmf-gray50)">
											</homefield-icon>
										}
									</picture>
								</button>
							</div>
						}
					</div>
				}
			</div>
		}
		<!--
			Display 'Option Not Available' if current sku is not shippable or bopisable
		-->
		@if (shouldShowOutOfStockRecs() && !alternativeInStockRecsEnabled()) {
			<div
				class="out-of-stock-recommendations-box hmf-display-flex hmf-flex-column hmf-justify-content-center">
				<div class="out-of-stock-box-text">OPTION NOT AVAILABLE</div>
				@if (nearbyStoreCount > 0 && !doesCurrentlySetStoreHaveInventory) {
					<div class="available-stores-out-of-stock-box-text">
						Available at
						<span class="number-of-available-stores-text"> {{ nearbyStoreCount }} </span
						>nearby stores within 100 miles
					</div>
					<a
						class="change-store-out-of-stock-box-link"
						(click)="toggleStoreLayerSideNav()"
						>Change Store</a
					>
				}
			</div>
		}
		<div
			[class.hmf-mt-xxs]="isHybridPLA()"
		>
			@if (mediaSetItems?.length > 2) {
				<ul
					class="pdp-mobile-carousel-dot-group hmf-display-flex hmf-justify-content-center hmf-p-0 hmf-mb-0"
					[class.hmf-display-md-none]="isHybridPLA()"
					[class.scrolling-dots]="isHybridPLA()"
					[class.hmf-mt-xxxs]="isHybridPLA()"
				>
					@for (
						mediaSetItem of mediaSetItems | slice: 1 : mediaSetItems.length;
						track $index
					) {
						<li
							class="pdp-mobile-carousel-dot"
							[class.current]="heroImage?.index === $index"
							[style.transform]="mobileHybridPLADotOffset()"
						></li>
					}
				</ul>
			}
			<!-- desktop hybrid PLA dot logic -->
			@if (isHybridPLA() && mediaSetItems?.length > 3) {
				<ul
					class="pdp-mobile-carousel-dot-group hmf-display-md-flex hmf-display-none hmf-justify-content-center hmf-p-0 hmf-mb-0 hmf-mt-xxxs">
					@for (dot of desktopHybridPLADots(); track dot.index) {
						<li
							class="pdp-mobile-carousel-dot"
							[class.current]="dot.active"
						></li>
					}
				</ul>
			}
		</div>
	</div>
</div>
